import { all } from '@redux-saga/core/effects';

import { searchSagas } from '@ducks/search/search.sagas';
import { authSagas } from '@ducks/auth/auth.sagas';

export function* sagas() {
  yield all([searchSagas(), authSagas()]);
}
